import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { ChevronRight } from '@bibliocommons/base-icons';
import { Link } from '@bibliocommons/base-links';

import breadcrumbLinksShape from 'app/shapes/breadcrumbLinksShape';

import './Breadcrumbs.scss';

const Breadcrumbs = ({ className, hasUiRouterLinks, links }) => {
  return (
    <nav aria-label="bread crumbs" className={cn('cp-breadcrumbs', className)}>
      <ol className="list">
        {links.map((link, index) => {
          const { label, url } = link;
          const isLastCrumb = index === links.length - 1;

          return (
            <li className="list-item" key={url}>
              {isLastCrumb ? (
                <span className="current">{label}</span>
              ) : (
                <>
                  {hasUiRouterLinks ? (
                    <RouterLink className="link" to={url}>
                      {label}
                    </RouterLink>
                  ) : (
                    <Link className="link" dataKey={url} href={url}>
                      {label}
                    </Link>
                  )}
                  <span aria-hidden="true">
                    <ChevronRight className="separator" />
                  </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

Breadcrumbs.defaultProps = {
  className: '',
  hasUiRouterLinks: false
};

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  hasUiRouterLinks: PropTypes.bool,
  links: breadcrumbLinksShape.isRequired
};

export default Breadcrumbs;
